import {AlertCircle, CheckCircle2, Clock} from 'lucide-react';
import {cn} from '@/lib/utils/cn';
import type {TransmissionOutcome} from '@/lib/api/types';

// Deliberately three states and no more. The raw `status` behind an outcome has
// eleven-odd spellings across three backend flows; collapsing them into
// reached / didn't reach / neither yet is the whole point of `outcome`.
const OUTCOME_META: Record<
  TransmissionOutcome,
  {label: string; className: string; Icon: typeof CheckCircle2}
> = {
  sent: {
    label: 'Sent',
    className: 'bg-success/15 text-success ring-success/30',
    Icon: CheckCircle2,
  },
  failed: {
    label: 'Failed',
    className: 'bg-destructive/15 text-destructive ring-destructive/30',
    Icon: AlertCircle,
  },
  pending: {
    label: 'Pending',
    className: 'bg-warning/15 text-warning ring-warning/30',
    Icon: Clock,
  },
};

interface OutcomePillProps {
  outcome: TransmissionOutcome;
  className?: string;
}

export function OutcomePill({outcome, className}: OutcomePillProps) {
  const meta = OUTCOME_META[outcome] ?? OUTCOME_META.pending;
  const {Icon} = meta;
  return (
    <span
      className={cn(
        'inline-flex items-center gap-1.5 rounded-full px-2.5 py-0.5 text-xs font-medium ring-1 ring-inset',
        meta.className,
        className
      )}
    >
      <Icon className="h-3 w-3" />
      {meta.label}
    </span>
  );
}
